"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: background 0.1s linear, color 0.1s linear, opacity 0.1s linear;\n  opacity: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  padding: ", " ", ";\n  ", " {\n    padding-left: ", "px;\n  }\n  &,\n  &::after {\n    background: ", ";\n  }\n  > .icon {\n    transition: color 0.1s linear, background 0.1s linear;\n    color: ", ";\n    font-size: ", ";\n    background: ", ";\n    border-radius: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: ", ";\n    height: ", ";\n    z-index: 2;\n  }\n  &:hover,\n  &.selected {\n    background: ", ";\n    color: ", ";\n    > .icon {\n      color: ", ";\n      background: ", ";\n    }\n  }\n  ", " {\n    position: relative;\n    &::before {\n      content: ' ';\n      display: block;\n      position: absolute;\n      top: 50%;\n      bottom: 0;\n      left: calc(", " - 1px + ", " / 2);\n      width: 2px;\n      background: ", ";\n      transition: background 0.1s linear;\n    }\n    &.selected::before,\n    &:hover::before {\n      background: ", ";\n    }\n  }\n  ", " {\n    position: relative;\n    &::before {\n      content: ' ';\n      display: block;\n      position: absolute;\n      top: 0;\n      bottom: ", ";\n      left: calc(", " - 1px + ", " / 2);\n      width: 2px;\n      background: ", ";\n      transition: background 0.1s linear;\n    }\n    &::after {\n      content: ' ';\n      display: block;\n      position: absolute;\n      top: 50%;\n      left: calc(\n        ", " - ", " / 2 +\n          ", " / 2\n      );\n      margin-top: calc(", " / -2);\n      width: ", ";\n      height: ", ";\n      border-radius: 2px;\n      transform: rotate(45deg);\n      border: solid 2px\n        ", ";\n      transition: border 0.1s linear, background 0.1s linear;\n    }\n    &.selected::before,\n    &:hover::before,\n    &.line-highlight::before {\n      background: ", ";\n    }\n    &.selected::after,\n    &:hover::after,\n    &.line-highlight::after {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalNavigationItem = void 0;

var react_1 = __importDefault(require("react"));

var ClickableContainer_1 = require("./dom/ClickableContainer");

var isNative_1 = require("./isNative");

var styled_1 = require("./styled");

var Block_1 = require("./styled/Block");

var List_1 = require("./styled/List");

var theme_1 = require("./theme");

var typography_1 = require("./typography");

function ModalNavigationItem(_a) {
  var children = _a.children,
      onClick = _a.onClick,
      index = _a.index,
      label = _a.label,
      icon = _a.icon,
      selected = _a.selected,
      depth = _a.depth,
      disabled = _a.disabled,
      parentSelected = _a.parentSelected,
      lineHighlighted = _a.lineHighlighted,
      hasChildren = _a.hasChildren,
      lastChild = _a.lastChild,
      rest = __rest(_a, ["children", "onClick", "index", "label", "icon", "selected", "depth", "disabled", "parentSelected", "lineHighlighted", "hasChildren", "lastChild"]);

  return react_1.default.createElement(react_1.default.Fragment, null, isNative_1.isNative && index !== 0 ? react_1.default.createElement(List_1.ListSeparator, null) : null, react_1.default.createElement(ClickableContainer_1.ClickableContainer, {
    onClick: onClick,
    disabled: disabled
  }, react_1.default.createElement(_ModalNavigationItem, Object.assign({
    space: '@size-xs',
    depth: depth,
    className: [selected ? 'selected' : '', lineHighlighted ? 'line-highlight' : ''].join(' '),
    disabled: disabled,
    parentSelected: parentSelected,
    hasChildren: hasChildren,
    lastChild: lastChild
  }, rest), children ? children : react_1.default.createElement(react_1.default.Fragment, null, icon ? react_1.default.createElement("div", {
    className: 'icon'
  }, icon) : null, react_1.default.createElement(typography_1.Body, {
    weight: typography_1.FontWeight.SemiBold
  }, label)))));
}

exports.ModalNavigationItem = ModalNavigationItem;

var _ModalNavigationItem = (0, styled_1.styled)(Block_1.HSpaced)(_templateObject(), function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@gray-5');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-xs');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-m');
}, function (props) {
  return props.depth ? '&' : '&.noop';
}, function (props) {
  var left = (0, theme_1.sizeToNumber)((0, theme_1.getSize)(props.theme, '@size-m'));
  var icon = (0, theme_1.sizeToNumber)((0, theme_1.getSize)(props.theme, '@size-m')) + (0, theme_1.sizeToNumber)((0, theme_1.getSize)(props.theme, '@size-xs'));
  var extra = Math.max(0, (0, theme_1.sizeToNumber)((0, theme_1.getSize)(props.theme, '@size-s')) * (props.depth - 1));
  return left + icon + extra;
}, function (props) {
  return props.depth ? (0, theme_1.getColor)(props.theme, props.parentSelected ? '@gray-2' : '@gray-1') : '@gray-1';
}, function (props) {
  return props.theme['@gray-5'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@gray-2'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@gray-2'];
}, function (props) {
  return props.theme['@primary-color'];
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@primary-color'];
}, function (props) {
  return props.hasChildren ? '&' : '&:noop';
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@gray-2');
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@primary-color');
}, function (props) {
  return props.depth ? '&' : '&.noop';
}, function (props) {
  return props.lastChild ? '50%' : 0;
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return (0, theme_1.getColor)(props.theme, props.parentSelected ? '@gray-3' : '@gray-2');
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return (0, theme_1.getColor)(props.theme, props.parentSelected ? '@gray-3' : '@gray-2');
}, function (props) {
  return props.theme['@primary-color'];
}, function (props) {
  return props.theme['@primary-color'];
});